module.exports = __webpack_public_path__ + "media/audio43.6b2260c5.mp3";